import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ChatWidget from "../../components/feature/ChatWidget";
import SEOHead from "../../components/feature/SEOHead";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import ServicesPreview from "./components/ServicesPreview";
import { Link } from "react-router-dom";
import { blogPosts } from "../../mocks/blog";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "AccountingService",
  "name": "Vidal Ferrer Asesores",
  "description": "Asesoría fiscal y laboral en Pego con más de 25 años de experiencia. Optimización tributaria, gestión de nóminas, seguros y constitución de empresas.",
  "url": `${import.meta.env.VITE_SITE_URL ?? "https://vidalferrerassessors.es"}`,
  "telephone": "+34965571831",
  "email": "assessoriagrevi@gmail.com",
  "image": "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/5d198e02-b50f-45ba-886f-dccec1174f60_oficina-2.jpeg?v=b61451c6b5da901fd090839ad1b382f6",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "C/ Duanes, 14",
    "addressLocality": "Pego",
    "addressRegion": "Alicante",
    "postalCode": "03780",
    "addressCountry": "ES"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 38.8422,
    "longitude": -0.1211
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "13:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday"],
      "opens": "16:00",
      "closes": "19:00"
    }
  ],
  "priceRange": "$$",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "Marina Alta, Alicante"
  },
  "sameAs": []
};

export default function Home() {
  const recentPosts = blogPosts.slice(0, 3);

  return (
    <>
      <SEOHead
        title="Vidal Ferrer Asesores · Asesoría Fiscal Laboral y Seguros en Pego"
        description="Vidal Ferrer Asesores, asesoría fiscal y laboral en Pego con más de 25 años de experiencia. Optimización tributaria, gestión de nóminas, seguros y constitución de empresas. Primera consulta gratuita."
        keywords="asesoría fiscal Pego, asesoría laboral Alicante, seguros empresariales, gestoría Pego"
        canonical="/"
        jsonLd={homeJsonLd}
      />
      <Navbar />

      <main>
        <HeroSection />
        <StatsSection />
        <ServicesPreview />

        {/* CTA Banner */}
        <section className="py-20 bg-[#1A1A1A] relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://public.readdy.ai/ai/img_res/9e27c6ddb91dfe5317a24f748f610155.jpg"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 max-w-screen-xl mx-auto px-6 md:px-10 text-center">
            <p className="text-[#A0D080] text-sm font-semibold uppercase tracking-widest mb-4">¿Tienes dudas?</p>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 max-w-3xl mx-auto leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Primera consulta gratuita y sin compromiso
            </h2>
            <p className="text-white/70 text-lg max-w-2xl mx-auto mb-10">
              Analizamos tu situación fiscal y laboral sin coste alguno. Te explicamos cómo podemos ayudarte y qué ahorro puedes conseguir.
            </p>
            <Link
              to="/contacto"
              className="inline-flex items-center gap-2 bg-[#6B7F5C] hover:bg-[#5A6E4B] text-white font-semibold px-10 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-base"
            >
              Solicitar consulta gratuita
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </Link>
          </div>
        </section>

        {/* Blog Preview */}
        <section className="py-20 bg-[#F8F7F4]">
          <div className="max-w-screen-xl mx-auto px-6 md:px-10">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
              <div>
                <p className="text-[#6B7F5C] text-sm font-semibold uppercase tracking-widest mb-3">Blog</p>
                <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A]" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Últimas novedades fiscales
                </h2>
              </div>
              <Link
                to="/blog"
                className="flex items-center gap-1 text-[#6B7F5C] font-medium hover:gap-2 transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                Ver todos los artículos
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </div>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {recentPosts.map((post) => (
                <article key={post.id} className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300">
                  <div className="h-44 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="bg-[#F0F4ED] text-[#6B7F5C] text-xs font-medium px-2.5 py-1 rounded-full">
                        {post.category}
                      </span>
                      <span className="text-[#6B6B6B] text-xs">{post.date}</span>
                    </div>
                    <h3 className="font-bold text-[#1A1A1A] mb-2 leading-snug text-sm md:text-base">
                      {post.title}
                    </h3>
                    <p className="text-[#6B6B6B] text-sm leading-relaxed line-clamp-2 mb-4">
                      {post.excerpt}
                    </p>
                    <Link
                      to="/blog"
                      className="flex items-center gap-1 text-[#6B7F5C] text-sm font-medium hover:gap-2 transition-all cursor-pointer"
                    >
                      Leer más
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line" />
                      </div>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Why us */}
        <section className="py-20 bg-white">
          <div className="max-w-screen-xl mx-auto px-6 md:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
              <div>
                <p className="text-[#6B7F5C] text-sm font-semibold uppercase tracking-widest mb-4">¿Por qué elegirnos?</p>
                <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Tu asesoría de confianza
                </h2>
                <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
                  Somos un equipo de 12 profesionales certificados con especialización en fiscalidad, derecho laboral y seguros. Cada cliente tiene un asesor dedicado que conoce su situación en profundidad.
                </p>
                <div className="space-y-4">
                  {[
                    { icon: "ri-time-line", title: "Respuesta en menos de 24h", desc: "Resolvemos tus dudas con rapidez para que no pierdas tiempo valioso." },
                    { icon: "ri-lock-line", title: "Total confidencialidad", desc: "Tu información está protegida. Cumplimos estrictamente con el RGPD." },
                    { icon: "ri-team-line", title: "Asesor dedicado personalizado", desc: "Un experto exclusivo para tu empresa que conoce todos los detalles." },
                    { icon: "ri-refresh-line", title: "Actualización normativa constante", desc: "Siempre al día con cambios legislativos para que no te pille por sorpresa." },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-4">
                      <div className="w-10 h-10 bg-[#F0F4ED] rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${item.icon} text-[#6B7F5C] text-lg`} />
                      </div>
                      <div>
                        <p className="font-semibold text-[#1A1A1A] text-sm mb-0.5">{item.title}</p>
                        <p className="text-[#6B6B6B] text-sm">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20consulting%20team%20meeting%20room%20presentation%20modern%20office%20elegant%20interior%20warm%20natural%20light%20business%20professionals%20discussion%20minimal%20neutral%20tones%20sophisticated%20workspace&width=650&height=520&seq=why1&orientation=landscape"
                  alt="Equipo Vidal Ferrer Asesores"
                  className="w-full h-[400px] md:h-[500px] object-cover object-top rounded-2xl"
                />
                <div className="absolute -bottom-5 -left-5 bg-[#6B7F5C] text-white p-5 rounded-xl">
                  <p className="text-3xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>+25</p>
                  <p className="text-sm text-white/80">años de experiencia</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <ChatWidget />
    </>
  );
}
